module.exports = __webpack_public_path__ + "static/client14-a12d5d7b051c3de0f3c3bae1b8ab4e25.png";